import { CustomNextImage } from '@crehana/next';

import { useCourseDetailCourse } from '../hooks';

const CoursePromoImage: React.FC = () => {
  const { course } = useCourseDetailCourse();

  if (!course.promoImage) {
    return null;
  }

  return (
    <CustomNextImage
      src={course.promoImage}
      alt={course.title}
      layout="fill"
      sizes="(max-width: 1365px) 100vw, 20vw"
      objectFit="cover"
      objectPosition="top"
      priority
    />
  );
};

export default CoursePromoImage;
